import React, { useCallback } from 'react';
import identity from 'lodash/identity';
import { AnyObject } from 'react-final-form';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

import DraftEditor from 'Shared/components/DraftEditor/DraftEditor';
import { editorStateForEditorComponent } from 'Shared/utils/draftJsHelpers';
import { meetingItemTypes } from 'Shared/constants/constants';
import RoundCheckbox from 'Shared/components/Checkboxes/RoundCheckbox/RoundCheckbox';
import Avatar from 'Shared/components/Avatar/Avatar';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

export default function CommentsListItem({ item, onOpenToggle }: AnyObject) {
  const history = useHistory();
  const { tr } = useTranslation();

  const handleClick = useCallback(() => {
    onOpenToggle();
    (window as any).analytics.track('Clicked Search Results', { type: 'workspace_comment', item });
    setTimeout(() => history.push(item.path));
  }, [history, item, onOpenToggle]);

  return (
    <div style={{ textDecoration: 'none', color: 'black' }} onClick={handleClick}>
      <div className="d-flex flex-column w-100 px-4 py-2 border-bottom search-module-results-item">
        <div className="d-flex align-items-center justify-content-between w-100">
          <div className="d-flex align-items-center">
            <RoundCheckbox checked={item.meetingItem?.completed} />
            <div className="d-flex font-weight-bold ml-2 search-module-results-item-text">
              <DraftEditor
                readOnly
                onChange={identity}
                editorState={editorStateForEditorComponent(item.meetingItem?.body)}
              />
            </div>
          </div>
          <button className="btn text-primary p-0 search-module-results-item-view-button" type="button">
            {tr('perform.search.comment.view_button')}
          </button>
        </div>
        <div className="d-flex flex-column rounded bg-light ml-4 my-2 p-2" style={{ border: '1px solid #ABC3FD' }}>
          <div className="d-flex align-items-center mt-1">
            <Avatar avatar={item.user.avatar} height={25} />
            <p className="text-uppercase m-0 ml-2" style={{ fontSize: '11px', lineHeight: '147%' }}>
              {tr(
                'perform.search.comment.left_comment',
                item.user.firstName,
                item.user.lastName,
                moment(item.createdAt).format('ll')
              )}
            </p>
          </div>
          <div className="font-weight-bold" style={{ marginLeft: '2rem' }}>
            <DraftEditor readOnly onChange={identity} editorState={editorStateForEditorComponent(item.body)} />
          </div>
        </div>
        <div className="list-item-info d-flex text-muted">
          {tr('perform.search.comment.type_label')}
          <b className="mx-1">{meetingItemTypes[item.meetingItem?.itemType]}</b>
          {tr('perform.search.comment.workspace_label')}
          <b className="mx-1">{item.meetingItem?.workspaceName}</b>
        </div>
      </div>
    </div>
  );
}
